<template>
  <ExportDialog
    v-model:visibility="visibilityExportDialog"
    :account-filter="filter" />

  <main class="flex flex-col gap-6">
    <div class="table-controls-container flex items-center justify-between">
      <div class="flex w-full items-center gap-3">
        <SmInput
          v-model="searchQuery"
          outline
          style="width: 300px"
          size="medium"
          :label="i18n.t('searchEmail')" />

        <!-- Filter -->
        <SmDropdown
          :close-on-click-inside="false"
          dropdown-class="w-[42rem] max-w-7xl">
          <template #trigger>
            <SmButton outline size="small">
              <div class="flex items-center gap-2">
                <Filter :size="18" />
                <span>{{ i18n.t('filter') }}</span>
                <span v-if="filterCount"> ({{ filterCount }}) </span>
              </div>
            </SmButton>
          </template>

          <div style="padding: 1rem">
            <AccountFilterDialog
              v-model:filter="filter"
              :software-licenses="licenseTable?.softwareLicenses || []"
              :show-applications-filter="true"
              :close-on-click-inside="false" />
          </div>
        </SmDropdown>

        <SmTooltip class="ml-auto" :content="i18n.t('download')">
          <SmButton @click="getAndDownloadLicensesCSV">
            <Download class="export-icon text-white" :size="18" />
            <span style="margin-left: 0.5rem"> {{ i18n.t('csv') }} </span>
          </SmButton>
        </SmTooltip>
      </div>
    </div>
    <el-card
      shadow="always"
      class="grow overflow-auto"
      :body-style="{
        height: '100%',
        width: '100%',
      }">
      <AccountTable
        ref="licenseTable"
        :filter="filter"
        display-application-name
        display-status
        display-price />
    </el-card>
  </main>
</template>

<script lang="ts" setup>
  import { useI18n } from 'vue-i18n'

  import ExportDialog from '@/components/shared/ExportDialog.vue'
  import LicenseTable from '@/components/accounts/AccountTable.vue'
  import { AccountFilters } from '@/stores/account/account.filter'
  import { Download, Filter } from 'lucide-vue-next'
  const licenseTable = ref<InstanceType<typeof LicenseTable>>()

  const i18n = useI18n()

  const searchQuery = ref<string>('')

  const visibilityExportDialog = ref<boolean>(false)

  function getAndDownloadLicensesCSV() {
    visibilityExportDialog.value = true
  }

  // Filter
  const filter = ref<AccountFilters>({})

  // Handle filter count
  const filterCount = computed(() => {
    return Object.keys(filter.value).filter((key) => {
      const filterKey = filter.value[key as keyof AccountFilters]

      return filterKey !== undefined && filterKey !== null
    }).length
  })

  // trim the search query to prevent empty string incrementing the counter
  watch(searchQuery, () => {
    const trimmedQuery = searchQuery.value.trim()
    filter.value.email = trimmedQuery.length > 0 ? trimmedQuery : undefined
  })
</script>

<!-- <style lang="scss" scoped>
  main.fooo {
    background-color: red;
  }
</style> -->
